import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import {dispatchEvent} from "fg-frontend/src/lib/dom";

const fragments = {
	SUBMIT_BTN: 'button[type=submit]',
	FORM: 'form',
	ESP_CONTAINER: '.esp-fixed-container',
	ESP_CLOSE: '.esp__fixed-close',
	FORM_INPUTS: 'input.form-control',
	FORM_FIRST_HAS_ERROR: '.form-group.has-error',
	FORM_HAS_REQUIRED_INPUT: 'input[required]',
};

class EspPopupCustom extends WebComponent {

	constructor(props) {
		super(props);
		const {
		} = props;
		this.state = {};
	}

	didMount() {
		const {
		} = this.props;

		this.formElement = this.element.querySelector(fragments.FORM);
 		this.submitBtnElement = this.element.querySelector(fragments.SUBMIT_BTN);
 		this.espCloseElement = document.querySelector(fragments.ESP_CLOSE);
		window.addEventListener('mousedown', this.handleClickOnContainer);
		this.formHasRequiredInput = this.element.querySelectorAll(fragments.FORM_HAS_REQUIRED_INPUT);
		let keyPressListener = null;
		this.on('keyup', fragments.FORM_INPUTS, function(e) {
			clearTimeout(keyPressListener);
			keyPressListener = setTimeout(function() {
				dispatchEvent(e.target, 'requestValidation', false);
			}, 250);
		});
		const partialUpdateForceEl = this.element.querySelector('.partialUpdateForce');
		if(!partialUpdateForceEl) {
			$(document).on('validationPassed', this.initFormValidation);
			$(document).on('validationFailed', this.initFormValidation);
			document.addEventListener('afterContentsReplaced', () => {
				if(this.element == null) {
					this.element = document.querySelector('[data-is="EspPopupCustom"]');
				}
				if(this.element != null) {
					this.formHasRequiredInput = this.element.querySelectorAll(fragments.FORM_HAS_REQUIRED_INPUT);
				}
				this.initFormValidation();
			});
		}
		this.formFirstHasError = this.element.querySelector(fragments.FORM_FIRST_HAS_ERROR);
		if (this.formFirstHasError) {
			this.formFirstHasError.scrollIntoView({behavior: 'smooth'});
		}

		const espDelayShowCloseBtn = this.element.getAttribute('data-esp-delay-show-close-btn');
		if(espDelayShowCloseBtn != null) {
			this.espCloseElement = document.querySelector(fragments.ESP_CLOSE);
			if(this.espCloseElement) {
				this.espCloseElement.classList.add('esp__fixed-close--hidden');
				let timerCount = parseInt(espDelayShowCloseBtn);
				this.espCloseElement.innerHTML = timerCount.toString();
				var timer = setInterval(() => {
					timerCount--;
					this.espCloseElement.innerHTML = timerCount.toString();
				}, 1000);
				setTimeout(() => {
					clearTimeout(timer);
					this.espCloseElement.innerHTML = '';
					let forceContainer = document.querySelector('.esp-fixed-container--force');
					forceContainer.classList.remove('esp-fixed-container--force');
					this.espCloseElement.classList.remove('esp__fixed-close--hidden');
				}, parseInt(espDelayShowCloseBtn) * 1000);
			}
		}

		/* cookie expires */
		const espCookieExpires = this.element.getAttribute('data-esp-cookie-expires');
		if(espCookieExpires != null) {
			const espCookieName = this.element.getAttribute('data-esp-cookie-name');
			this.setCookie(espCookieName, 0, espCookieExpires)
		}
	}

	initValidationPassed = () => {
		if(this.submitBtnElement) {
			this.submitBtnElement.classList.add('noPartialUpdate');
		}
	};

	initValidationFailed = () => {
		if(this.submitBtnElement) {
			this.submitBtnElement.classList.remove('noPartialUpdate');
		}
	};

	initFormValidation = () => {
 		let i = 0;
 		let formHasRequiredInputEmpty = 0;
 		for (i; i < this.formHasRequiredInput.length; i++) {
			if (this.formHasRequiredInput[i].value === '') {
			  formHasRequiredInputEmpty++;
			}
		}
		if (formHasRequiredInputEmpty > 0) {
			this.initValidationFailed();
		} else {
			this.initValidationPassed();
		}
	};

	handleClickOnContainer = (e) => {
		if(e.which === 1) {
			let forceContainer = document.querySelector('.esp-fixed-container--force');
			if(e.target.classList.contains('esp--fixed')) {
				if(forceContainer == null) {
				   this.espCloseElement.click();
				}
			}
		}
	}

	setCookie(cName, cValue, cDate) {
		let expires = '';
		if(parseInt(cDate) > 0){
			let d = new Date();
			d.setTime(d.getTime() + (cDate*24*60*60*1000));
			expires = "expires="+ d.toUTCString();
		}
		document.cookie = cName + "=" + cValue + ";" + expires + ";path=/";
	}
}

export default EspPopupCustom;



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/EspPopupCustom.js